const status = [
  {
    label: "HD",
    value: "HD",
  },
  {
    label: "TH",
    value: "TH",
  },
  {
    label: "DO",
    value: "DO",
  },
  {
    label: "G",
    value: "G",
  },
];

export default status;
